import axios, {
  AxiosRequestConfig,
  AxiosError,
  AxiosResponse,
  AxiosInstance,
} from 'axios';
import { TFunction } from 'i18next';
import { translateErrorMessages } from './error.utils';
import { cookiesHelper } from '../../helpers';
import { SESSION_TOKEN } from '../../constants';

const axiosOptions = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const handleCancelRequest = () => {
  const cancelResult = {
    statusCode: 429,
    message: 'Cancel Request',
    error: 'Cancel Request',
  };
  return Promise.reject(cancelResult);
};

export const createGuestAxiosInstance = (
  baseURL: string,
  t?: TFunction, // optional i18n translator
): AxiosInstance => {
  const axiosInstance = axios.create({ ...axiosOptions, baseURL });

  // Request interceptor - handles guest token
  axiosInstance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const sessionToken = cookiesHelper.get(SESSION_TOKEN);
      if (sessionToken) {
        config.headers = {
          ...config.headers,
          'x-secure-token': sessionToken,
        };
      }
      return config;
    },
    (error: AxiosError) => Promise.reject(error),
  );

  // Simplified response interceptor - only handles cancellation and error translation
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
      const { response } = error;

      if (axios.isCancel(error)) return handleCancelRequest();

      if (response?.data?.details && t) {
        const rawError = response.data;
        const finalError = translateErrorMessages(rawError, t);
        return Promise.reject(finalError);
      }

      return Promise.reject(response?.data || error);
    },
  );

  return axiosInstance;
};
